module.exports = __webpack_public_path__ + "img/orange_066.09b0ea8f.png";